import { Button, Col, Form, Input, Modal, Radio, Row, Space } from "antd";
import { isArray } from "lodash";

function StationModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
}) {
  const handleFinish = (values) => {
    let coordinates = isArray(values.location.coordinates)
      ? values.location.coordinates
      : values.location.coordinates.split(",").map((item) => +item);
    values.location = {
      type: "Point",
      coordinates: coordinates,
    };
    onSave(values, data.serial_number);
  };

  return (
    <Modal
      title={isUpdate ? "Update Station" : "Add Station"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={handleFinish}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
              }
            : {
                is_active: true,
              }
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please input Name",
                },
              ]}
            >
              <Input placeholder="Name" />
            </Form.Item>
          </Col>
          {/* <Col span={12}>
            <Form.Item
              label="Station Number"
              name="station_number"
              rules={[
                {
                  required: true,
                  message: "Please input Station Number",
                },
              ]}
            >
              <Input placeholder="Station Number" />
            </Form.Item>
          </Col> */}
        </Row>
        <div>Address</div>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="Street" name={["address", "street"]}>
              <Input placeholder="Street" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="City"
              name={["address", "city"]}
              rules={[
                {
                  required: true,
                  message: "Please input City",
                },
              ]}
            >
              <Input placeholder="City" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="State"
              name={["address", "state"]}
              rules={[
                {
                  required: true,
                  message: "Please input State",
                },
              ]}
            >
              <Input placeholder="State" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="zip"
              name={["address", "zip"]}
              rules={[
                {
                  required: true,
                  message: "Please input zip",
                },
              ]}
            >
              <Input placeholder="Zip" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Cordinates"
              name={["location", "coordinates"]}
              style={{
                marginBottom: 0,
              }}
              rules={[
                {
                  required: true,
                  message: "Please select Coordinates",
                },
              ]}
            >
              <Input placeholder="Coordinates" />
            </Form.Item>
            <div style={{ color: "grey", marginBottom: 10 }}>eg: lat,long</div>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Status"
              name="is_active"
              rules={[
                {
                  required: true,
                  message: "Please select Status",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Active</Radio>
                <Radio value={false}> In-Active </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default StationModal;
